<template>
  <div
    class="lty-my-perks-point-item small-8 medium-12 large-12"
    :class="{ 'is-not-header': !isHeader }"
  >
    <div class="grid-x align-justify">
      <div
        class="lty-perks-head cell align-center align-middle padding-bottom-xs padding-top-xs"
        :class="clsPerkHeader"
      >
        <p
          class="lty-perks-text-header"
          v-html="perk.perkTitle"
        ></p>
        <p
          v-if="perk.perkDec"
          class="small lty-perks-text-description"
          v-html="perk.perkDec"
        ></p>
      </div>
      <div
        v-if="brand === 'mcom'"
        class="grid-x cell small-9 medium-8 large-8 align-middle align-center grid-margin-x"
      >
        <PerkDetails
          :value="perk.BRONZE"
          class="perk-BRONZE"
          :class="{ 'is-header': isHeader, [headerPadding]: isHeader }"
          :is-header="isHeader"
        />
        <PerkDetails
          :value="perk.SILVER"
          class="perk-SILVER"
          :class="{ 'is-header': isHeader, [headerPadding]: isHeader }"
          :is-header="isHeader"
        />
        <PerkDetails
          :value="perk.GOLD"
          class="perk-GOLD"
          :class="{ 'is-header': isHeader, [headerPadding]: isHeader }"
          :is-header="isHeader"
        />
        <PerkDetails
          :value="perk.PLATINUM"
          class="perk-PLATINUM"
          :class="{ 'is-header': isHeader, [headerPadding]: isHeader }"
          :is-header="isHeader"
        />
      </div>
      <div
        v-else
        class="grid-x cell small-9 medium-8 large-6 align-middle align-center grid-margin-x"
      >
        <PerkDetails
          :value="perk.LOYALLIST"
          class="perk-LOYALLIST"
          :class="{ 'is-header': isHeader, [headerPadding]: isHeader }"
          :is-header="isHeader"
        />
        <PerkDetails
          :value="perk.TOL"
          class="perk-TOL"
          :is-header="isHeader"
          :class="{ 'is-header': isHeader, [headerPadding]: isHeader }"
        />
        <PerkDetails
          :value="perk.UNL"
          class="perk-UNL"
          :class="{ 'is-header': isHeader, [headerPadding]: isHeader }"
          :is-header="isHeader"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue';
import { brand, PERKS_LIST } from '../../config';
import PerkDetails from './PerkDetails';
/** Perks Component for MCOM/BCOM
 * MCOM - Bronze, Silver, Gold, Platinum
 * BCOM - Loyalist, TopOfTheList, UnLocked
 * AMEX - Offers Benefit Should Render on Conditional Base.
 */

const props = defineProps({
  perk: {
    type: Object,
    default() {
      return { perkTitle: '' };
    },
  },
  isHeader: Boolean,
});
const { perk, isHeader } = toRefs(props);
const headerPadding = 'small-padding-z small-padding-top-xs small-padding-bottom-xs medium-padding-xs';
const clsPerkHeader = PERKS_LIST.CLASS_PERK_HEADER;
</script>

<style lang="scss" scoped>
.lty-perks-head {
  .lty-perks-text-description {
    color: $gray-1-color;
  }
}
.lty-my-perks-point-item.is-not-header:not(:last-child) {
  border-bottom: rem-calc(1) dotted $gray-3-color;
}
.perk-BRONZE.is-header {
  border-top: rem-calc(10) solid $loyalty-1-color;
}
.perk-BRONZE {
  background: rgba(213, 114, 0, 0.1);
  height: 100%;
}
.perk-SILVER.is-header {
  border-top: rem-calc(10) solid $loyalty-2-color;
}
.perk-SILVER {
  background: rgba(214, 214, 214, 0.1);
}
.perk-GOLD.is-header {
  border-top: rem-calc(10) solid $loyalty-3-color;
}
.perk-GOLD {
  background: rgba(240, 192, 6, 0.1);
}
.perk-PLATINUM.is-header {
  border-top: rem-calc(10) solid $loyalty-4-color;
}
.perk-PLATINUM {
  background: rgba(137, 151, 160, 0.1);
}
.perk-LOYALLIST.is-header {
  border-top: rem-calc(10) solid $loyalty-1-color;
}
.perk-LOYALLIST {
  background: $loyalty-bg-1-color;
}
.perk-TOL.is-header {
  border-top: rem-calc(10) solid $loyalty-2-color;
}
.perk-TOL {
  background: $loyalty-bg-2-color;
}
.perk-UNL.is-header {
  border-top: rem-calc(10) solid $loyalty-3-color;
  color: $loyalty-4-color;
}
.perk-UNL {
  background: $loyalty-bg-4-color;
}
</style>


